export {default as color, rgb, hsl} from "./src/color";
export {default as lab, hcl} from "./src/lab";
export {default as cubehelix} from "./src/cubehelix";



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-color/index.js
// module id = VMIw
// module chunks = 0